<template>
  <Modal :cancelText="lang('取消')" :okText="lang('确定')" v-bind="$attrs">
    <slot></slot>
    <template #footer v-if="$slots.footer">
      <slot name="footer"></slot>
    </template>
  </Modal>
</template>

<script lang="tsx" setup name="SmartModal">
import { Modal } from 'ant-design-vue'
import { inject } from 'vue'
const lang = inject('lang')
</script>
